import FormData from "./FormData";
import MenuTabs from "./MenuTabs";
import NoItem from "./NoItem";
import QuickShareReview from "./QuickShareReview";

const shareComponents = {
  FormData,
  MenuTabs,
  NoItem,
  QuickShareReview
}

export default shareComponents